export const annaJaniszewska = {
    'mydrId': 'annajaniszewska',
    'firstName': 'Anna',
    'lastName': 'Janiszewska',
    'profession': 'Psychiatra, psychiatra dzieci i młodzieży',
    'avatar': 'anna-janiszewska.webp',
    'slug': 'anna-janiszewska-psychiatra',
    'locations': ['torun'],
    'services': [
        ['psychiatry', 'adult'],
        ['psychiatry', 'children'],
        ['diagnosis', 'autism'],
        ['diagnosis', 'asd'],
        ['diagnosis', 'adhd'],
    ]
}